import React, { useEffect, useState } from "react";
import CustomBreadcrumbs from "../../components/BreadCrums";
import { useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { getAgreement } from "../../graphql/queries";
import { getUrl } from "aws-amplify/storage";
import { Box, Stack, Button } from "@mui/material";
import ReadOnlyInput from "../../components/ReadOnlyInput";
import moment from "moment";
import { ArrowDownFromLine, ArrowDownToLine } from "lucide-react";
import { toast } from "react-toastify";

const AgreementPreviewPage = () => {
  const [agreement, setAgreement] = useState(null);
  const [agreementFileUrl, setAgreementFileUrl] = useState();
  const params = useParams();
  const breadcrumbItems = [
    { label: "Content Management", link: "/content" },
    { label: "Agreements", link: "/agreements" },
    { label: params ? params?.id : "View Content", link: null },
  ];
  const client = generateClient();

  useEffect(() => {
    const fetchAgreement = async () => {
      const response = await client.graphql({
        query: getAgreement,
        variables: {
          id: params.id,
        },
      });
      console.log(response.data.getAgreement);
      setAgreement(response.data.getAgreement);
    };
    fetchAgreement();
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (agreement?.agreementFilePath) {
      const fetchAgreementFileUrl = async () => {
        try {
          const response = await getUrl({
            key: agreement?.agreementFilePath,
            options: { validateObjectExistence: true },
          });
          console.log(response, "responseOfAgreement");
          setAgreementFileUrl(response.url.href);
        } catch (error) {
          toast.error("Unable to find the agreement file!");
        }
      };
      fetchAgreementFileUrl();
    }
    return () => {
      isMounted = false; // Cleanup function to avoid state updates if unmounted
    };
  }, [agreement]);

  const openAgreementInNewTab = () => {
    if (agreementFileUrl) {
      window.open(agreementFileUrl, "_blank");
    }
  };

  // Mapping labels and values for ReadOnlyInput
  const readOnlyInputs = [
    {
      label: "Term Of Agreement",
      value: `${agreement?.daysOfAgreement / 30} months`,
    },
    {
      label: "Licensing Region",
      value: agreement?.licensingRegion,
    },
    {
      label: "Country",
      value: agreement?.licensingCountry[0],
    },
    {
      label: "Number Of Refresh Cycles",
      value: agreement?.numberOfRefreshCycles,
    },
    {
      label: "Contract Value",
      value: agreement?.contractValue,
    },
    {
      label: "Amount Paid",
      value: agreement?.amountPaid,
    },
    {
      label: "Payment Plan",
      value: agreement?.paymentPlan,
    },
    {
      label: "Payment Term",
      value: agreement?.paymentTerm,
    },
    {
      label: "Date Of Agreement",
      value: moment(agreement?.createdAt).format("DD MMM YYYY"),
    },
  ];

  return (
    <div>
      <CustomBreadcrumbs items={breadcrumbItems} />
      {agreement && (
        <Box my={2}>
          <Stack flexBasis={"80%"} paddingX={2} gap={2}>
            {readOnlyInputs.map((input, index) => (
              <ReadOnlyInput
                key={index}
                label={`${input.label} : `}
                value={input.value}
                containerProps={{
                  sx: { display: "flex", alignItems: "center" },
                }}
                labelProps={{
                  sx: { minWidth: "250px", flexShrink: 0 },
                }}
                inputProps={{
                  sx: { flexGrow: 1 },
                }}
              />
            ))}
            {agreementFileUrl && (
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={openAgreementInNewTab}
                >
                  Download Agreement <ArrowDownToLine />
                </Button>
              </Box>
            )}
          </Stack>
        </Box>
      )}
    </div>
  );
};

export default AgreementPreviewPage;
